// src/components/SectorLeadersModal.jsx
// 섹터 클릭 → 그 섹터의 시총 대표주 팝업.
import React from "react";
import { SECTOR_LEADERS } from "../lib/sectorLeaders";

const spct = (n) => (n == null || isNaN(n)) ? "—" : `${n >= 0 ? "+" : ""}${(n * 100).toFixed(1)}%`;
const capTxt = (억) => 억 >= 10000 ? `${(억 / 10000).toFixed(1)}조` : `${억.toLocaleString()}억`;

export default function SectorLeadersModal({ sector, signal, thesis = null, myHoldings = [], onClose }) {
  const leaders = SECTOR_LEADERS[sector] || [];
  const tgMentions = thesis?.tgMentions || [];   // 텔레그램 자주 언급 종목
  const tgFeed = thesis?.tgFeed || [];            // 텔레그램 유의미 피드
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: 16 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: "#fff", borderRadius: 16, width: "min(680px, 95vw)", maxHeight: "88vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(0,0,0,0.15)" }}>
        <div style={{ padding: "16px 20px", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>{sector} · 시총 대표주</h3>
            {signal && (signal.mom != null || signal.intensity5 != null) && (
              <div style={{ fontSize: 11, color: "#888", marginTop: 3 }}>
                섹터 ETF — 모멘텀 {spct(signal.mom)} · 5일 수급 {spct(signal.intensity5)}
              </div>
            )}
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#aaa" }}>✕</button>
        </div>
        {thesis && (
          <div style={{ padding: "14px 20px", borderBottom: "1px solid #f0f0f0", background: "#fbfcfe" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
              {thesis.tag && <span style={{ fontSize: 11, fontWeight: 800, color: "#fff", background: "#1f3a93", borderRadius: 5, padding: "2px 7px" }}>#{thesis.tag}</span>}
              <span style={{ fontSize: 10.5, color: "#aaa" }}>논거 · {thesis.asof} {thesis.source === "user" ? "(직접)" : ""}</span>
            </div>
            <div style={{ fontSize: 12.5, color: "#333", lineHeight: 1.6 }}>{thesis.summary}</div>
            {thesis.drivers?.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 8 }}>
                {thesis.drivers.map((d, i) => (
                  <span key={i} style={{ fontSize: 11, color: "#1f3a93", background: "#eef3fb", border: "1px solid #dbe4f2", borderRadius: 999, padding: "2px 9px" }}>{d}</span>
                ))}
              </div>
            )}
            {thesis.catalysts?.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 800, color: "#555", marginBottom: 6 }}>📅 이벤트 캘린더</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                  {thesis.catalysts.map((c, i) => (
                    <div key={i} style={{ display: "flex", gap: 8, fontSize: 12, lineHeight: 1.45 }}>
                      <span style={{ flexShrink: 0, minWidth: 74, color: "#1f3a93", fontWeight: 700 }}>{c.date}</span>
                      <span style={{ color: "#444" }}>{c.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
          {/* 시총 대표주 */}
          <div style={{ padding: "8px 0", borderRight: "1px solid #f0f0f0", minWidth: 0 }}>
            <div style={{ padding: "6px 12px 4px", fontSize: 11, fontWeight: 800, color: "#888" }}>시총 대표주</div>
            {leaders.length === 0 ? (
              <div style={{ padding: 20, textAlign: "center", color: "#aaa", fontSize: 12 }}>없음</div>
            ) : leaders.map((s, i) => (
              <div key={s.c} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 16px", borderTop: i === 0 ? "none" : "1px solid #f6f6f6" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                  <span style={{ fontSize: 11, color: "#bbb", width: 14, textAlign: "right", flexShrink: 0 }}>{i + 1}</span>
                  <span style={{ fontSize: 12.5, fontWeight: 600, color: "#1a1a2e", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{s.n}</span>
                </div>
                <span style={{ fontSize: 11, color: "#777", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}>{capTxt(s.cap)}</span>
              </div>
            ))}
          </div>
          {/* 자주 언급 종목 (텔레그램) */}
          <div style={{ padding: "8px 0", borderRight: "1px solid #f0f0f0", minWidth: 0 }}>
            <div style={{ padding: "6px 12px 4px", fontSize: 11, fontWeight: 800, color: "#b8860b" }}>💬 자주 언급</div>
            {tgMentions.length === 0 ? (
              <div style={{ padding: 20, textAlign: "center", color: "#ccc", fontSize: 12 }}>—</div>
            ) : tgMentions.map((m, i) => (
              <div key={m.name + i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderTop: i === 0 ? "none" : "1px solid #f6f6f6" }}>
                <span style={{ fontSize: 12.5, fontWeight: 600, color: "#1a1a2e", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.name}</span>
                <span style={{ fontSize: 11, color: "#b8860b", fontWeight: 700, flexShrink: 0, marginLeft: 4 }}>{m.count}</span>
              </div>
            ))}
          </div>
          {/* 내 편입 종목 (해당 섹터) */}
          <div style={{ padding: "8px 0", minWidth: 0 }}>
            <div style={{ padding: "6px 12px 4px", fontSize: 11, fontWeight: 800, color: "#1f3a93" }}>📌 내 편입 ({myHoldings.length})</div>
            {myHoldings.length === 0 ? (
              <div style={{ padding: 20, textAlign: "center", color: "#ccc", fontSize: 12 }}>이 섹터 보유 없음</div>
            ) : myHoldings.map((h, i) => (
              <div key={String(h.ticker) + i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 16px", borderTop: i === 0 ? "none" : "1px solid #f6f6f6" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                  <span style={{ fontSize: 10, fontWeight: 800, color: h.short ? "#c0392b" : "#0a7c59", flexShrink: 0 }}>{h.short ? "S" : "L"}</span>
                  <span style={{ fontSize: 12.5, fontWeight: 600, color: "#1a1a2e", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{h.name}</span>
                </div>
                <span style={{ fontSize: 11, color: "#777", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}>{h.wPct != null ? h.wPct.toFixed(1) + "%" : "—"}</span>
              </div>
            ))}
          </div>
        </div>
        {tgFeed.length > 0 && (
          <div style={{ borderTop: "1px solid #f0f0f0", padding: "10px 20px 6px" }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: "#555", marginBottom: 7 }}>
              📨 텔레그램 피드 {thesis?.tgAsof && <span style={{ color: "#bbb", fontWeight: 500 }}>· {thesis.tgAsof}</span>}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
              {tgFeed.map((f, i) => (
                <div key={i} style={{ fontSize: 11.5, lineHeight: 1.45 }}>
                  <span style={{ color: "#1f3a93", fontWeight: 700, marginRight: 5 }}>{f.date}</span>
                  <span style={{ color: "#aaa", marginRight: 5 }}>@{f.ch}</span>
                  <a href={f.url} target="_blank" rel="noopener noreferrer" style={{ color: "#444", textDecoration: "none" }}>{f.text}</a>
                </div>
              ))}
            </div>
          </div>
        )}
        <div style={{ padding: "10px 20px 16px", fontSize: 10.5, color: "#bbb" }}>
          좌: 시총 상위주(Momo 유니버스) · 중: 텔레그램 자주언급 · 우: 내 편입. 매매판단은 별도.
        </div>
      </div>
    </div>
  );
}
